import React from 'react';
import { FaCamera, FaFile } from 'react-icons/fa';
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const StoreBannerInfoComponent = ({ storeBanner, changeBannerImage, handleChannelBannerItemChange }: any) => {
  return (
        <>
<div className="h-auto w-full bg-white  p-4 rounded">
<table className="w-full text-xs bg-red-50">
  <thead className="w-full border-y border-black border-opacity-20">
    <tr className="w-full text-left h-12">
        <th className="px-5">S.NO</th>
      <th className="px-5">Banner Image</th>
      <th className="px-5">Banner Message</th>
      <th className="px-5">Banner Label</th>
      <th className="px-5">BannerLabel Url</th>
    </tr>
  </thead>
  <tbody className="w-full h-auto">
  {storeBanner?.map((selectedStoreBanner: any, index: any) => (
      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
        <td className="px-5">{index + 1}</td>
        <td className="px-5">
          <div
           onClick={() => changeBannerImage(
                      index,
                      'BannerImage',
                      'image'
                    )}
                    >

          </div>
          <img
          
              src={selectedStoreBanner?.BannerImage}
              className="w-12 h-12"
          />
         <FaCamera  className=' text-2xl text-skin-ouprimary'/>
      
</td>
        <td className="px-5">
        <InputContainer
             label="Banner Message"
             name="Banner Message"
             onValueChange={(event: any) => {
               handleChannelBannerItemChange({
                 value: event.target.value,
                 field: 'BannerMessage',
                 idx: index
               });
             }}
             type="text"
             value={selectedStoreBanner?.BannerMessage}
         />
        </td>
       
        <td className="px-5">
        <InputContainer
             label="BannerLabel"
             name="BannerLabel"
             onValueChange={(event: any) => {
               handleChannelBannerItemChange({
                 value: event.target.value,
                 field: 'BannerLabel',
                 idx: index
               });
             }}
             type="text"
             value={selectedStoreBanner?.BannerLabel}
         />
        </td>
        <td className="px-5">
          <div onClick={() => changeBannerImage(
  index,
  'BannerLabelUrl',
  'document'
)}>
   <strong>{selectedStoreBanner?.BannerLabelUrl}</strong>
   <FaFile className=' text-2xl text-skin-ouprimary'/>
</div>
       
    
        </td>
      </tr>
    ))}
  
  </tbody>
  
</table>

</div>
   
        </>)
}
